import { useState } from "react";
import { useAccountant } from "@/contexts/AccountantContext";
import { useAuth } from "@/contexts/AuthContext";
import {
  dismissSetupReminder,
  getIncompleteSetupItems,
  isSetupReminderDismissed,
} from "@/lib/setupCompleteness";
import KipaIcon from "@/components/kipa/KipaIcon";
import { Sparkles } from "lucide-react";

export default function SetupReminderBanner({ onOpenSettings }) {
  const { settings } = useAccountant();
  const { user } = useAuth();
  const userKey = user?.id || user?.email || "";
  const [dismissed, setDismissed] = useState(() => isSetupReminderDismissed(userKey));
  const items = getIncompleteSetupItems(settings);

  if (!items.length || dismissed) return null;

  const summary =
    items.length === 1
      ? items[0].label
      : `${items.slice(0, -1).map((i) => i.label).join(", ")} and ${items[items.length - 1].label}`;

  return (
    <div
      className="mx-4 mt-3 mb-1 bg-[var(--al)] border border-[var(--ac)]/20 rounded-2xl p-3.5 flex gap-3 items-start"
      data-testid="setup-reminder-banner"
    >
      <KipaIcon icon={Sparkles} size="md" color="var(--color-primary)" className="mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-extrabold text-[var(--tx)] mb-0.5">Finish setting up your business</div>
        <div className="text-[12px] text-[var(--tx2)] leading-snug">
          You still haven&apos;t added your {summary}. Complete your profile so invoices and reports look professional.
        </div>
        <div className="flex gap-2 mt-2.5">
          <button
            type="button"
            onClick={onOpenSettings}
            className="px-3.5 py-2 rounded-xl bg-[var(--ac)] text-white text-[11px] font-extrabold"
            data-testid="setup-reminder-complete"
          >
            Complete setup
          </button>
          <button
            type="button"
            onClick={() => {
              dismissSetupReminder(userKey);
              setDismissed(true);
            }}
            className="px-3.5 py-2 rounded-xl bg-white border border-[var(--br)] text-[var(--tx2)] text-[11px] font-bold"
            data-testid="setup-reminder-later"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
